export const MIN_ARTS_TO_CREATE_CAMPAIGN = 5
